module.exports = __webpack_public_path__ + "img/3.bd9a381f.jpg";